import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from '@web/features/auth/LoginPage';
import { BoardPage } from '@web/features/board/BoardPage';
import { ParkedPage } from '@web/features/parked/ParkedPage';
import { SettingsPage } from '@web/features/settings/SettingsPage';
import { ThreadPage } from '@web/features/thread/ThreadPage';
import { AppShell } from './AppShell';
import { Protected } from './Protected';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<Protected />}>
        <Route element={<AppShell />}>
          <Route path="/board" element={<BoardPage />} />
          <Route path="/parked" element={<ParkedPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/thread/:id" element={<ThreadPage />} />
        </Route>
      </Route>

      {/* The board is the default screen; anything unrecognised lands there. */}
      <Route path="*" element={<Navigate to="/board" replace />} />
    </Routes>
  );
}
